import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import AppContext from '@/context/AppContext'

const useCustomLogisticsLabel = () => {
  const { context } = useContext(AppContext)
  const { i18n } = useTranslation()

  const messagesForLanguage = context?.merchantInfo?.preferences?.custom_messages?.[i18n.language]
  const logisticsFeeLabel = messagesForLanguage?.find(message => message.key === 'logistics_fee.label')

  return logisticsFeeLabel?.message
}

export default useCustomLogisticsLabel
